import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAdByIdApi } from "../../api/adsApi";
import { Ad } from "../ads/adsTypes";
import i18n from "../../i18n";

const normalizeAdDetails = (payload: any): Ad => {
  const raw = payload?.data && typeof payload.data === "object" ? payload.data : payload;

  const sortPriorityPhotoFirst = (photos: any[]) => {
    const priorityIndex = photos.findIndex((photo) => photo && typeof photo === "object" && photo.prioritaire === true);
    if (priorityIndex <= 0) return photos;
    const nextPhotos = [...photos];
    const [priorityPhoto] = nextPhotos.splice(priorityIndex, 1);
    return [priorityPhoto, ...nextPhotos];
  };

  const normalizedPhotos = Array.isArray(raw?.photos)
    ? sortPriorityPhotoFirst(raw.photos)
        .map((photo: any) =>
          typeof photo === "string"
            ? photo
            : photo?.url || photo?.name || photo?.path || photo?.src
        )
        .filter(Boolean)
    : [];

  return {
    ...raw,
    id: raw?.id ?? raw?._id,
    title_i18n: raw?.title_i18n || { fr: "", en: "", ar: "" },
    content_i18n: raw?.content_i18n || { fr: "", en: "", ar: "" },
    adress_i18n: raw?.adress_i18n || { fr: raw?.adress || "", en: "", ar: "" },
    photos: normalizedPhotos,
  } as Ad;
};

export const fetchAdDetailsById = createAsyncThunk<
  Ad,
  string,
  { rejectValue: string }
>(
  "adDetails/fetchById",
  async (id, thunkAPI) => {
    try {
      const response = await getAdByIdApi(id, thunkAPI.signal);
      const responsePayload: any = response?.data;
      const raw = responsePayload?.data && typeof responsePayload.data === "object"
        ? { ...responsePayload.data }
        : responsePayload && typeof responsePayload === "object"
          ? { ...responsePayload }
          : {};

      return normalizeAdDetails({ data: raw });
    } catch (err: any) {
      const message =
        err?.response?.data?.message || i18n.t("system.adDetailsLoadError");
      return thunkAPI.rejectWithValue(message);
    }
  }
);
